var promises = require("../../lib/promises");

exports.Files = Files;


function Files() {
    function read(uri) {
        return promises.reject(new Error("could not open external image: '" + uri + "'\ncannot open linked files from a web browser"));
    }
    
    return {
        read: read
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mammoth-style/browser/docx/files.js
// module id = 1938
// module chunks = 0